import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceflowForm from "@sourceflow-uk/sourceflowform";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,

} from "reactstrap";
import React, { useState, useEffect } from "react";
import styles from "./styles.module.scss";
import { trackMetaEvent } from "../../functions/metaPixel";

export default function SimpleForm({
  global,
  pathPrefix,
  content,
  customClass = "",
  form_id,
  heading,
  textCenter = false,
  page,
  form_header = <p>Let's make sure you get in touch with the right team</p>,
}) {
  const [modal, setModal] = useState(false);
  const toggle_modal = () => setModal(!modal);

  return (
    <section className={`${styles.root} ${customClass}`}>
      <Container>
        {content ? (
          <div className={`${textCenter ? "text-center" : ""}`}>
            <SourceFlowText
              global={global}
              path={`${pathPrefix}.content`}
              type="html"
            >
              {content}
            </SourceFlowText>
          </div>
        ) : (
          ""
        )}
        {form_id && (
          <>
            <div className="mt-5 pb-1">
              <div className="mb-5 form-wrapper rounded p-4 border">
                <div className=" p-md-4 ms-md-5 me-md-5">
                  {/* <h3
                    className={`${
                      textCenter ? "text-md-center" : ""
                    } mb-4 text-white`}
                  >
                    <SourceFlowText
                      global={global}
                      path={`${pathPrefix}.heading`}
                    >
                      {heading}
                    </SourceFlowText>
                  </h3> */}
                  <div className="d-flex flex-wrap aligm-items-center mb-3 custom-dropdown">
                    {/* <div className="mb-2 text-white w-100">
                      <SourceFlowText
                        global={global}
                        path={`${pathPrefix}.form_header`}
                        type="html"
                      >
                        {form_header}
                      </SourceFlowText>
                    </div> */}

                    <SourceflowForm
                      onSubmitDone={() => { trackMetaEvent("Lead"); toggle_modal(); }}
                      formId={form_id}
                    />
                  </div>

                  {modal ? (
                    <Modal isOpen={modal} toggle={toggle_modal}>
                      <ModalHeader toggle={toggle_modal} tag={"div"}>
                        <div className="w-100 text-center">
                          <h5 className="heading mb-0">
                            <strong>Submission Successful</strong>
                          </h5>
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        <p>We'll be in touch soon</p>
                      </ModalBody>
                    </Modal>
                  ) : null}
                </div>
              </div>
            </div>
          </>
        )}
      </Container>
    </section>
  );
}
